const statusLabelMap: { [key: string]: string } = {
  unknown: 'Unknown',
  low: 'Low',
  medium: 'Medium',
  high: 'High'
}

export const getAdverseInformationHitRiskLevelLabel = (name: string): string => statusLabelMap[name] || name
